import * as React from "react";
import {cx} from "emotion";

import "./yard-sign.scss";

import {IsShowPricing}          from "@Common/logic/check-show-pricing";
import {cs}                     from "@Common/react/chain-services";
import {stateChangeNestedValue} from "@Common/react/state-change-nested-value";
import {Select}                 from "@Common/ui-components/heavy/common/design2/select/select";
import {values}                 from "@Common/utils/objects";

import {MoneySpanOld} from "@Xpresso/routes/common/form/money-span/money-span";

export const YardSign = ({ state, calSelected, yardSignOptions, className }) => cs(
    ["showPricing", (_, next) => IsShowPricing({next})],
    ({showPricing}) => (
        <div className={cx("yard-sign-p3h", className)}>
            <div className="header">
                <div className="title">Yard Sign Options</div>
            </div>
            <div className="card">
                <div className="select">
                    {Select({
                        list: [null, ...values(yardSignOptions)] || [],
                        itemToLabel: (o) => o == null ? "None" : o.name,
                        itemToInfo: (o) => (o == null || !showPricing) ? null : MoneySpanOld({value: o.flatPrice ?? 0}),
                        isSelected: (o) => calSelected ? o?.dev_key === calSelected.dev_key : o == null,
                        onChange: (o) => state.onChange(o?.dev_key ?? null),
                        forcedExpandLeft: true,
                        xdQaName: "Yard Sign Options",
                    })}
                </div>

                {calSelected?.dev_key && (
                    <div className="description">
                        {calSelected.description}
                    </div>
                )}
            </div>
        </div>
    )
);
